export const AppWorkerRoles = ["LABELER", "REVIEWER"] as const

export type AppWorkerRole = typeof AppWorkerRoles[number]

export const AppWorkerRole = {
    LABELER: "LABELER",
    REVIEWER: "REVIEWER"
} as const

export function toDisplayText(role: AppWorkerRole): string {
    return role === "LABELER" ? "Annotator" : "Reviewer"
}
